"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function ClassroomButton(props) {
    const { children, iconName, selected, onClick, className } = props;
    return ((0, jsx_runtime_1.jsxs)(Button, { className: className, onClick: onClick, "$selected": selected, "data-e2e": 'ClassroomButton_Button', children: [iconName && ((0, jsx_runtime_1.jsx)(StyledIcon, { name: iconName, width: 20, height: 20, selected: selected, "data-e2e": 'ClassroomButton_StyledIcon' })), (0, jsx_runtime_1.jsx)(Label, { "$leftMargin": !!iconName, "data-e2e": 'ClassroomButton_Label', children: children })] }));
}
exports.default = ClassroomButton;
const Button = (0, styled_components_1.default)(ui_1.FlatButton) `
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  width: 150px;
  height: 44px;
  margin: 0;
  padding: 0;

  color: ${props => props.theme.white};

  background-color: ${props => props.$selected ? props.theme.accentGreen : props.theme.black_50};
  border-radius: 2px;

  cursor: pointer;

  pointer-events: auto;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  margin: auto 5px auto auto;
`;
const Label = styled_components_1.default.div `
  margin: auto auto auto ${props => (props.$leftMargin ? '5px' : 'auto')};

  font-size: 11px;
  text-transform: uppercase;
`;
